module.exports = __webpack_public_path__ + "static/img/theCategoryIntro.5caa4c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/theCategoryIntro.png
// module id = ojlO
// module chunks = 3